import moment from 'moment';
import { Contacts, IS_NOT_NULL_OR_UNDEFINED, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

export const EMAIL_VALIDATED_TOOLTIP = (contact: Contacts) => {
	if (IS_NOT_NULL_OR_UNDEFINED(contact.vettingAuthorizationOverrideAt)) {
		return `Contact validated by C4 admin on ${moment(new Date(contact.vettingAuthorizationOverrideAt)).format('MM/DD/YYYY')}`;
	}
	return IS_NULL_OR_UNDEFINED(contact.lastVettingTime)
		? ''
		: `Contact validated on ${moment(new Date(contact.lastVettingTime)).format('MM/DD/YYYY')}`;
};
